import { FC } from "react";

import { injectIntl, IntlShape } from "react-intl";

import { Text } from "@/components/atoms/Text";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/molecules/Accordion";
import TableSettings from "@/icons/__generated__/TableSetting/TableSetting24";
import { IFaqs } from "~/types/api-types";

import {
  category_labels,
  subtitles,
  eventFaqDefinition,
} from "../data/event-faq-definitions";
import {
  renderEntryTitle,
  furnitureSelected,
} from "../data/event-faq-display-sections";

import Description from "./Description";
import { analyticEventOnClick } from "./faq-utils";

interface FurnitureProps {
  faqData: IFaqs;
  intl: IntlShape;
  userID: string;
  listingID: string;
}

interface FurnitureOptions {
  tables: string;
  chairs: string;
  soft_seating: string;
}

const Furniture: FC<FurnitureProps> = ({
  faqData,
  intl,
  userID,
  listingID,
}) => {
  const furnitureTypesSelected = furnitureSelected(
    faqData,
  ) as (keyof FurnitureOptions)[];

  const label = intl.formatMessage(category_labels.furniture);

  const findAvailableFurniture = (furniture: string) => {
    const furnitureData =
      faqData[furniture as keyof FurnitureOptions]?.description;
    return furnitureData ? true : false;
  };

  const findFurnitureDescription = (furniture: string) => {
    const furnitureData = faqData[furniture as keyof FurnitureOptions];
    return furnitureData ? (furnitureData.description as string) : "";
  };

  return (
    <div className="EventFAQ">
      <Accordion
        type="multiple"
        onValueChange={() => {
          analyticEventOnClick(userID, listingID, "Furniture");
        }}
      >
        <AccordionItem value="furniture-section">
          <AccordionTrigger className="tw-py-24">
            <div className="tw-flex tw-gap-12 tw-items-center">
              <TableSettings />
              <Text element="h3" typeface="headline-1-m">
                {label}
              </Text>
            </div>
          </AccordionTrigger>
          <AccordionContent className="tw-ml-36 tw-pb-24 tw-space-y-8">
            {furnitureTypesSelected.length > 0 && (
              <>
                {furnitureTypesSelected.map((furniture, key) => (
                  <div key={key}>
                    <Text typeface="body-2-m">
                      {intl.formatMessage(subtitles[furniture])}
                    </Text>
                    <div className="faq-body flex margin-lg-bottom">
                      {renderEntryTitle(
                        eventFaqDefinition.furniture?.[furniture] || {
                          id: "",
                          defaultMessage: "",
                        },
                        faqData[furniture]?.quantity,
                        furniture,
                      )}
                      {findAvailableFurniture(furniture) && (
                        <Description
                          description={findFurnitureDescription(furniture)}
                          textSmall
                        />
                      )}
                    </div>
                  </div>
                ))}
              </>
            )}
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default injectIntl(Furniture);
